// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!./node_modules/css-loader/dist/cjs.js!./node_modules/webfonts-loader/index.js!./bobcaticons.font.js");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!./node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2035b7a3", content, true, {});